module.exports = __webpack_public_path__ + "static/media/icon-supplies-sheitelhead.a779e76c.svg";